import { IconX } from "@tabler/icons-react";
import { FieldErrors, UseFormRegister } from "react-hook-form";
import TextareaField from "../../../components/common/TextareaField";
import ButtonStyled from "../../../components/common/ButtonStyled";

type DeleteModalProps = {
  open: boolean;
  onClose: () => void;
  deleteOrder: () => void;
  isDeletePending: boolean;
  register: UseFormRegister<any>;
  errors: FieldErrors<any>;
  clearErrors?: any;
  setValue?: any;
  watch?: any;
  inPlace?: boolean;
};

export default function DeleteModal({
  open,
  onClose,
  deleteOrder,
  isDeletePending,
  register,
  errors,
  inPlace = false,
}: DeleteModalProps) {
  if (!open) return null;

  if (inPlace) {
    return (
      <div className="bg-white border border-slate-200/80 shadow-lg rounded-2xl overflow-hidden flex flex-col">
        {/* Header */}
        <div className="flex justify-between items-center px-5 py-4 border-b border-slate-100 bg-white">
          <h3 className="text-base font-bold text-[#212121]">Delete</h3>
          <div className="flex items-center gap-2">
            <ButtonStyled
              type="button"
              onClick={deleteOrder}
              isPending={isDeletePending}
              variant="outline"
              value="Confirm"
            />
            <button
              type="button"
              onClick={onClose}
              className="p-1.5 rounded-lg border border-[#D2D2D2] hover:bg-slate-100 transition-colors text-slate-700 bg-slate-50 cursor-pointer"
            >
              <IconX size={16} />
            </button>
          </div>
        </div>

        {/* Body — compact without extra space */}
        <div className="p-4 bg-white">
          <div className="group relative rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
            <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
            <TextareaField
              rows={2}
              className="flex items-center gap-2 rounded-lg relative z-10"
              label="Comment"
              register={register}
              name="comment"
              placeholder="Enter reason for deletion..."
              error={errors.comment}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed top-0 left-0 w-full h-screen bg-black/60 z-50 flex items-center justify-end p-4">
      <div className="bg-white rounded-2xl w-full max-w-[500px] flex flex-col relative bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] shadow-2xl overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-[#d2d2d2] bg-white shrink-0">
          <h3 className="text-lg font-bold text-[#212121]">Delete Order</h3>
          <div className="flex items-center gap-2">
            <ButtonStyled
              type="button"
              onClick={deleteOrder}
              isPending={isDeletePending}
              variant="outline"
              value="Confirm"
            />
            <button
              type="button"
              onClick={onClose}
              className="p-1.5 rounded-lg border border-[#D2D2D2] hover:bg-gray-100 transition-colors text-slate-700 bg-[#F2F2F7] cursor-pointer"
            >
              <IconX size={16} />
            </button>
          </div>
        </div>

        {/* BODY */}
        <div className="w-full p-6 bg-white">
          <div className="group relative rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
            <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
            <TextareaField
              rows={3}
              className="flex items-center gap-2 rounded-lg relative z-10"
              label="Comment"
              register={register}
              name="comment"
              placeholder="Enter reason for deletion..."
              error={errors.comment}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
